import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-numeric-input',
  templateUrl: './numeric-input.component.html',
  styleUrls: ['./numeric-input.component.scss']
})
export class NumericInputComponent implements OnInit, OnChanges {
  @Input() value: number = 0;
  @Input() min: number = 0;
  @Input() max: number = 10;
  @Input() step: number = 1;
  @Input() size: string = 'sm';
  @Input() disabled: boolean = false;
  @Output() valueChange = new EventEmitter<number>();

  constructor() { }

  ngOnInit(): void {
    this.validateValue();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value']) {
      this.validateValue();
    }
  }

  onValueChange(event: any) {
    let newValue = parseFloat(event.target.value);

    // Si el valor es NaN, vacío o null, usar el valor mínimo
    if (isNaN(newValue) || event.target.value === '' || event.target.value === null) {
      newValue = this.min;
    }

    // Validar rango
    if (newValue < this.min) {
      newValue = this.min;
    } else if (newValue > this.max) {
      newValue = this.max;
    }

    // Asegurar que sea un número entero
    newValue = Math.round(newValue);

    if (this.value !== newValue) {
      this.value = newValue;
      this.valueChange.emit(this.value);
    }

    // Actualizar el valor en el input para que se muestre correctamente
    event.target.value = this.value;
  }

  private validateValue() {
    // Si el valor es null, undefined o NaN, usar el valor mínimo
    if (this.value === null || this.value === undefined || isNaN(this.value)) {
      this.value = this.min;
      this.valueChange.emit(this.value);
      return;
    }

    let validValue = this.value;

    if (validValue < this.min) {
      validValue = this.min;
    } else if (validValue > this.max) {
      validValue = this.max;
    }

    // Asegurar que sea un número entero
    validValue = Math.round(validValue);

    if (this.value !== validValue) {
      this.value = validValue;
      this.valueChange.emit(this.value);
    }
  }
}
